// extracted by mini-css-extract-plugin
export var allFeatures = "index-module--allFeatures--Ldh1S";
export var feature = "index-module--feature--snUGC";
export var icon = "index-module--icon--6jHSA";
export var joinUsFeatures = "index-module--joinUsFeatures--2B7e4";